document.addEventListener('DOMContentLoaded', () => {
    const feedbackWidget = document.querySelector('.feedback-widget');
    if (!feedbackWidget) return;

    const buttons = feedbackWidget.querySelectorAll('[data-function="feedback"]');
    const prompt = feedbackWidget.querySelector('.prompt');
    const confirmation = feedbackWidget.dataset.confirmation;
    const container = document.getElementById('feedback');
    const surveyLink = feedbackWidget.querySelector('.feedback-survey-link');
    const openSurveyBtn = document.getElementById('open-survey');

    const modal = document.getElementById('survey-modal');
    const modalForm = document.getElementById('survey-form');

    let currentFeedbackId = null;
    const COOKIE_NAME = 'survey_submitted';

    // Cookie helpers
    const setCookie = (name, value, days) => {
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=Lax";
    };

    const getCookie = (name) => {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    };

    // --- Feedback Logic ---
    buttons.forEach(button => {
        button.addEventListener('click', async e => {
            const response = e.currentTarget.dataset.response;

            // Disable buttons and show confirmation
            container.classList.add('responded');
            buttons.forEach(btn => {
                btn.disabled = true;
                btn.classList.add('hidden');
            });
            prompt.textContent = confirmation;

            // Show "Tell us more" button
            if (openSurveyBtn) {
                openSurveyBtn.classList.remove('hidden');
            }

            const totalTimeMs = parseInt(localStorage.getItem('survey_total_time') || 0);
            const secondsActive = Math.round(totalTimeMs / 1000);

            // Send response to server
            try {
                const res = await fetch(feedback.ajax_url, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: new URLSearchParams({
                        action: 'record_feedback',
                        response,
                        seconds_active: secondsActive,
                        path: window.location.pathname,
                        page_title: document.title,
                        nonce: feedback.nonce
                    })
                });
                const data = await res.json();
                if (data.success && data.data.feedback_id) {
                    currentFeedbackId = data.data.feedback_id;
                }
            } catch (err) {
                console.error('Feedback failed to send:', err);
            }

            // Send to Google Analytics (GA4)
            if (typeof gtag === 'function') {
                gtag('event', 'feedback_response', {
                    response,
                    page_path: window.location.pathname
                });
            }
        });
    });

    // --- Survey Modal Logic ---
    const showModal = () => {
        if (!modal) return;

        modal.showModal();
        document.body.style.overflow = 'hidden'; // Prevent scroll

        // Mark as shown for 24h lockout
        localStorage.setItem('survey_last_shown', Date.now());
    };

    const hideModal = () => {
        modal.close();
        document.body.style.overflow = '';
    };


    if (openSurveyBtn) openSurveyBtn.addEventListener('click', showModal);

    // Harmonized close actions
    document.querySelectorAll('[data-action="close-survey"]').forEach(btn => {
        btn.addEventListener('click', hideModal);
    });

    // Close on click outside (backdrop)
    if (modal) {
        modal.addEventListener('click', e => {
            const dialogDimensions = modal.getBoundingClientRect();
            if (
                e.clientX < dialogDimensions.left ||
                e.clientX > dialogDimensions.right ||
                e.clientY < dialogDimensions.top ||
                e.clientY > dialogDimensions.bottom
            ) {
                hideModal();
            }
        });
    }

    if (modalForm) {
        modalForm.addEventListener('submit', async e => {
            e.preventDefault();

            const formData = new FormData(modalForm);
            const answers = {};
            feedback.survey_settings.questions.forEach((q, index) => {
                const answer = formData.get(`q_${index}`);
                if (answer) {
                    const key = q.reporting_id || q.question;
                    answers[key] = {
                        q: q.question,
                        a: answer
                    };
                }
            });

            const totalTimeMs = parseInt(localStorage.getItem('survey_total_time') || 0);
            const secondsActive = Math.round(totalTimeMs / 1000);

            try {
                await fetch(feedback.ajax_url, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: new URLSearchParams({
                        action: 'record_survey',
                        feedback_id: currentFeedbackId || '',
                        answers: JSON.stringify(answers),
                        seconds_active: secondsActive,
                        path: window.location.pathname,
                        page_title: document.title,
                        nonce: feedback.survey_nonce
                    })
                });

                // Set cookie based on data attribute
                const expirationDays = parseInt(modal.dataset.surveySubmittedExpiration) || 30;
                setCookie(COOKIE_NAME, 'true', expirationDays);

                // UI Changes on complete
                const surveyCompleteButtons = document.getElementById('survey-complete-buttons');
                const surveyConfirmation = document.getElementById('survey-confirmation');
                const surveyHeading = document.getElementById('survey-heading');

                if (surveyCompleteButtons) surveyCompleteButtons.classList.remove('hidden');
                if (surveyConfirmation) surveyConfirmation.classList.remove('hidden');
                if (modalForm) modalForm.classList.add('hidden');
                if (surveyHeading) surveyHeading.classList.add('hidden');

                if (surveyLink) surveyLink.style.display = 'none';
            } catch (err) {
                console.error('Survey failed to send:', err);
            }
        });
    }

    // --- Auto-popup Logic ---
    const checkAutoPopup = () => {
        const autoPopupDelay = parseInt(modal.dataset.autoPopup) || 0;
        const delay = autoPopupDelay * 1000;
        if (delay <= 0) return;

        // Don't show if they've already submitted the survey recently
        if (getCookie(COOKIE_NAME)) return;

        const lockout = 24 * 60 * 60 * 1000; // 24 hours
        const now = Date.now();

        // Inactivity reset (24h)
        // If they haven't been on the site for >24h, clear everything.
        const lastSession = parseInt(localStorage.getItem('survey_last_session') || 0);
        if (lastSession && (now - lastSession > lockout)) {
            localStorage.setItem('survey_total_time', 0);
            localStorage.setItem('survey_last_shown', 0);
        }
        localStorage.setItem('survey_last_session', now);

        setInterval(() => {
            // Only count time if the page is visible
            if (document.visibilityState !== 'visible') return;

            const updatedNow = Date.now();
            let totalTime = parseInt(localStorage.getItem('survey_total_time') || 0);
            totalTime += 1000;

            localStorage.setItem('survey_total_time', totalTime);
            localStorage.setItem('survey_last_session', updatedNow); // Keep session fresh

            // Show modal if threshold met AND lockout expired
            if (totalTime >= delay) {
                const lastShown = parseInt(localStorage.getItem('survey_last_shown') || 0);
                if (!lastShown || (updatedNow - lastShown >= lockout)) {
                    showModal();
                }
            }
        }, 1000);
    };

    checkAutoPopup();
});
